import { Radio, RadioGroup } from '@thanx/uikit/radio'
import { Text } from '@thanx/uikit/text'
import { MenuLayout } from 'api/landingPageTheme'
import Section from 'components/Section'
import palette from 'constants/palette'
import { useRbacManageDisabled } from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import React from 'react'
import { MenuLayoutState } from '../useMenuLayout'

const t = buildTranslate('cms.content.menu_category.menu_layout')

const OPTIONS: MenuLayout[] = ['tabs', 'continuous_scroll']

const DESCRIPTION_STYLE = { maxWidth: '100%', color: palette.grey70 }

type Props = {
  menuLayout: MenuLayoutState
}

const MenuLayoutSection = ({ menuLayout }: Props) => {
  const { enabled, hasTheme, selectedLayout, setSelectedLayout } = menuLayout
  const permissionDisabled = useRbacManageDisabled('AppConfiguration')

  if (!enabled) return null

  return (
    <Section className="p-m my-m">
      <Text.Header4>{t('title')}</Text.Header4>
      <p className="body-text-4 grey-70">{t('description')}</p>
      {hasTheme ? (
        <RadioGroup
          name="menu-layout"
          aria-label={t('title')}
          value={selectedLayout}
          onChange={value => setSelectedLayout(value as MenuLayout)}
        >
          {OPTIONS.map(option => (
            <Radio
              key={option}
              className="mb-m"
              value={option}
              checked={selectedLayout === option}
              disabled={permissionDisabled}
              description={t(`options.${option}_explanation`)}
              overrides={{
                Input: {
                  props: { 'aria-describedby': `menu-layout-${option}-hint` },
                },
                Description: {
                  style: DESCRIPTION_STYLE,
                  props: { id: `menu-layout-${option}-hint` },
                },
              }}
            >
              {t(`options.${option}`)}
            </Radio>
          ))}
        </RadioGroup>
      ) : (
        <p className="body-text-4 grey-70">{t('no_theme')}</p>
      )}
    </Section>
  )
}

export default MenuLayoutSection
